var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"flex justify-start my-4 cursor-pointer"},[_c('input',{staticClass:"mr-2",attrs:{"type":"radio","name":"answer"},domProps:{"value":_vm.id},on:{"change":r => _vm.changeValue(r)}}),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }